import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useWorkshops } from '../WorkshopContext';

const bmPin = new L.Icon({  
  iconUrl: process.env.PUBLIC_URL + '/location-dot-solid.svg',
  iconSize: [28, 65],
  iconAnchor: [14, 65]
});

const selectedPin = new L.Icon({
  iconUrl: process.env.PUBLIC_URL + '/location-dot-solid-selected.svg',
  iconSize: [38, 95],
  iconAnchor: [19, 95]
});

const checkedPin = new L.Icon({
  iconUrl: process.env.PUBLIC_URL + '/location-dot-solid-checked.svg',
  iconSize: [28, 65],
  iconAnchor: [14, 65]
});

const selectedCheckedPin = new L.Icon({
  iconUrl: process.env.PUBLIC_URL + '/location-dot-solid-selected-checked.svg',
  iconSize: [38, 95],
  iconAnchor: [19, 95]
});

// Starting map position
const position = [54.5260, 15.2551];

const MapComponent = ({ workshops }) => {

  const { state, dispatch } = useWorkshops();
  const items = typeof workshops !== 'undefined' ? workshops : state.workshops;

  return (
    <div className="container">
      <div id="map" className="map-container">
        <MapContainer center={position} zoom={4} style={{ height: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {items.map((workshop) => {
            const isCurrentlySelected = state.selectedWorkshopId === workshop.id;
            const isInComparison = state.selectedWorkshops.includes(workshop.id);
            
            let icon;
            if (isCurrentlySelected && isInComparison) {
              icon = selectedCheckedPin;
            } else if (isCurrentlySelected) {
              icon = selectedPin;
            } else if (isInComparison) {
              icon = checkedPin;
            } else {
              icon = bmPin;
            }
            
            return (
              <Marker
                key={workshop.id}
                position={[workshop.lat, workshop.lon]}              
                icon={icon}
                eventHandlers={{
                  click: () => {
                    dispatch({ type: 'set_selected', payload: workshop.id });
                    if (process.env.NODE_ENV === "development") {
                      console.log("selecting ...");
                      console.log(state.selectedWorkshops);
                    }
                  },
                }}
              >
                <Tooltip direction="top" offset={[0, -50]} opacity={1} permanent={false}>
                  {`${workshop.id}. ${workshop.name}${(Array.isArray(workshop.land_uses) && workshop.land_uses.length) ? ` (${workshop.land_uses.join(', ')})` : ''}`}
                </Tooltip>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
};

export default MapComponent;
